import { API_ROOT } from "config.js";

const ASSET_TYPES_ENDPOINT = `${API_ROOT}/api/assets/types`;
const ASSETS_ENDPOINT = `${API_ROOT}/api/assets`;
const ASSET_AGENTS_ENDPOINT = `${API_ROOT}/api/assets/agents`;
const ASSET_ATTRIBUTES_ENDPOINT = `${API_ROOT}/api/assets/attributes`;

function validateResponse(response) {
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
}

export async function getAssetTypes(axios) {
  try {
    const response = await axios.get(ASSET_TYPES_ENDPOINT);
    validateResponse(response);
    return response.data || [];
  } catch (error) {
    if (error.response && [401, 404].includes(error.response.status)) {
      return [];
    }
    throw error;
  }
}

export async function createAssetType(axios, payload) {
  const response = await axios.post(ASSET_TYPES_ENDPOINT, payload);
  validateResponse(response);
  return response.data;
}

export async function getAssets(axios) {
  try {
    const response = await axios.get(ASSETS_ENDPOINT);
    validateResponse(response);
    return response.data || [];
  } catch (error) {
    if (error.response && [401, 404].includes(error.response.status)) {
      return [];
    }
    throw error;
  }
}

export async function getAsset(axios, assetId) {
  const response = await axios.get(`${ASSETS_ENDPOINT}/${assetId}`);
  validateResponse(response);
  return response.data;
}

export async function createAsset(axios, payload) {
  const response = await axios.post(ASSETS_ENDPOINT, payload);
  validateResponse(response);
  return response.data;
}

export async function updateAsset(axios, assetId, payload) {
  const response = await axios.patch(`${ASSETS_ENDPOINT}/${assetId}`, payload);
  validateResponse(response);
  return response.data;
}

export async function deleteAsset(axios, assetId) {
  const response = await axios.delete(`${ASSETS_ENDPOINT}/${assetId}`);
  validateResponse(response);
  return response.data;
}

export async function createAssetAttribute(axios, assetId, payload) {
  const response = await axios.post(
    `${ASSETS_ENDPOINT}/${assetId}/attributes`,
    payload,
  );
  validateResponse(response);
  return response.data;
}

export async function updateAssetAttribute(axios, attributeId, payload) {
  const response = await axios.patch(
    `${ASSET_ATTRIBUTES_ENDPOINT}/${attributeId}`,
    payload,
  );
  validateResponse(response);
  return response.data;
}

export async function deleteAssetAttribute(axios, attributeId) {
  const response = await axios.delete(
    `${ASSET_ATTRIBUTES_ENDPOINT}/${attributeId}`,
  );
  validateResponse(response);
  return response.data;
}

export async function getAssetAgents(axios, assetId = "") {
  const endpoint = assetId
    ? `${ASSETS_ENDPOINT}/${assetId}/agents`
    : ASSET_AGENTS_ENDPOINT;
  try {
    const response = await axios.get(endpoint);
    validateResponse(response);
    return response.data || [];
  } catch (error) {
    if (error.response && [401, 404].includes(error.response.status)) {
      return [];
    }
    throw error;
  }
}

export async function createAssetAgent(axios, payload) {
  const response = await axios.post(ASSET_AGENTS_ENDPOINT, payload);
  validateResponse(response);
  return response.data;
}

export async function updateAssetAgent(axios, agentId, payload) {
  const response = await axios.patch(
    `${ASSET_AGENTS_ENDPOINT}/${agentId}`,
    payload,
  );
  validateResponse(response);
  return response.data;
}

export async function deleteAssetAgent(axios, agentId) {
  const response = await axios.delete(`${ASSET_AGENTS_ENDPOINT}/${agentId}`);
  validateResponse(response);
  return response.data;
}

export function buildAssetTree(assets = []) {
  const map = new Map();
  const roots = [];

  assets.forEach((asset) => {
    map.set(asset.id, { ...asset, children: [] });
  });

  map.forEach((node) => {
    if (node.parent && map.has(node.parent)) {
      map.get(node.parent).children.push(node);
    } else {
      roots.push(node);
    }
  });

  return roots;
}
